export default {
  downloads: {
    description:
      "Logiciels nécessaires au diagnostic et à la programmation des machines Brokk.",
    itemName: "Logiciels",
    size: "Dimensions",
    subtitle: "Téléchargez les logiciels pour les machines Brokk."
  }
}
